import { useContext, useCallback } from 'react'
import { IntakeContext } from 'context/IntakeContext'

export const useIntake = () => {
  const intakeContext = useContext(IntakeContext)

  return intakeContext
}
